import styled, { css } from 'styled-components';
import { styleHelpers, mixins, media } from '@pik/pik-ui';

const S = {};

S.FraudPrevention = styled.div`
  width: 100%;
  box-sizing: border-box;
  
  @media ${media.max768}{
  
  }
`;

S.Content = styled.div`
  ${mixins.flex('row', 'nowrap', 'space-between', 'initial')};
  width: 100%;
  
  @media ${media.max768}{
    display: block;
  }
`;

S.Left = styled.div``;

S.Links = styled.div`
  ${mixins.flexWidth('288px')};
  box-sizing: border-box;
  margin-left: 64px;

  @media ${media.max768}{
    flex: initial;
    width: calc(100% + 32px);
    margin-left: -16px;
    margin-bottom: 32px;
  }
`;

S.FormWrapper = styled.div`
  width: calc(100% - 288px - 64px);
  
  @media ${media.max768}{
    width: 100%;
  }
`;

S.Title = styled.div`
  font-size: 64px;
  line-height: 74px;
  margin-bottom: 96px;
  letter-spacing: -0.01em;
  color: ${styleHelpers.colors.black};
  font-weight: ${styleHelpers.fontWeight.medium};
  max-width: 768px;

  @media ${media.max768}{
    max-width: initial;
    font-size: 44px;
    line-height: 48px;
    margin-bottom: 16px;
  }
`;

S.Description = styled.div`
  width: 100%;
  font-size: 24px;
  line-height: 32px;
  color: ${styleHelpers.colors.black};
  margin-bottom: 68px;

  p:not(:last-of-type){
    margin-bottom: 32px;
  }
  
  @media ${media.max768}{
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 16px;
  }
`;

S.Form = styled.div`
  ${mixins.flex()};
  width: 100%;
  
  @media ${media.max768}{
    display: block;
  }
`;

S.InputWrapper = styled.div`
  width: 100%;
  margin-right: 32px;

  @media ${media.max768}{
    margin-right: 0;
  }
`;

S.ButtonWrapper = styled.div`
  @media ${media.max768}{
    width: 100%;
    margin-top: 16px;
  }
`;

S.Link = styled.div`
  background: #F7F7F5;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 16px;
  cursor: pointer;
  
  &:not(:last-of-type){
    margin-bottom: 8px;
  }
  
  @media ${media.max768}{
    ${mixins.flexWidth('256px')};
    min-height: 80px;
    white-space: normal;
    
    &:first-of-type {
      margin-left: 16px;
    }
    
    &:not(:last-of-type){
      margin-bottom: 0;
    }

    margin-right: 16px;
  }
`;

S.LinkText = styled.span`
  font-size: 16px;
  line-height: 24px;
  color: ${styleHelpers.colors.black};
`;

S.Result = styled.div(({ isSuccess, isError }) => css`
  ${mixins.flex('row', 'nowrap', 'space-between', 'center')};
  width: 100%;
  padding: 24px 32px 24px 24px;
  box-sizing: border-box;
  border-radius: 8px;
  margin-top: 48px;
  
  ${isSuccess && css`
    background: rgba(65, 217, 90, 0.08);
  `};

  ${isError && css`
    background: rgba(254, 48, 48, 0.08);
  `};
  
  @media ${media.max768}{
    display: block;
    margin-top: 16px;
    padding: 16px;
  }
`);

S.ResultBlock = styled.div``;

S.ResultResource = styled.div`
  font-size: 24px;
  line-height: 24px;
  letter-spacing: -0.001em;
  font-weight: ${styleHelpers.fontWeight.medium};
  color: ${styleHelpers.colors.black};
  ${mixins.ellipsis()};
`;

S.ResultText = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: ${styleHelpers.colors.black};
  margin-top: 12px;
`;

S.ResultLabel = styled.div`
  ${mixins.flex('row', 'nowrap', 'initial', 'center')};
  margin-left: 8px;

  @media ${media.max768}{
    margin-left: 0;
    margin-top: 24px;
  }
`;

S.ResultLabelIcon = styled.div`
  ${mixins.flex()};
  margin-right: 8px;
`;

S.ResultLabelText = styled.div(({ isSuccess, isError }) => css`
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.001em;
  font-weight: ${styleHelpers.fontWeight.medium};
  
  ${isSuccess && css`
    color: #41D95A;
  `};
  
  ${isError && css`
    color: #FE3030;
  `};
`);

S.ModalContent = styled.div``;

S.ModalContentTitle = styled.div`
  font-size: 20px;
  line-height: 24px;
  letter-spacing: -0.01em;
  color: ${styleHelpers.colors.black};
  font-weight: ${styleHelpers.fontWeight.medium};
  margin-bottom: 24px;
`;

S.ModalContentList = styled.div`
  width: 100%;
`;

S.ModalContentListItem = styled.a(({ isFraud }) => css`
  display: block;
  width: 100%;
  padding: 24px;
  box-sizing: border-box;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.001em;
  color: ${styleHelpers.colors.black};
  font-weight: ${styleHelpers.fontWeight.medium};
  background: #F7F7F5;
  border-radius: 12px;
  text-decoration: none;
  
  ${isFraud && css`
    pointer-events: none;
  `};
  
  &:not(:last-of-type){
    margin-bottom: 4px;
  }
`);

export default S;
